module.exports = __webpack_public_path__ + "static/img/upload.84d5b598.svg";